<template>
  <el-card shadow="never" class="aui-card--fill batch-settlement-page">
    <el-row style="background-color: #f3f4f4" v-if="ReceiverVisible !== true" type="flex" class="row-bg"
      justify="space-between">
      <el-col :xs="24" :md="7" style="
          line-height: 40px;
          font-size: 16px;
          color: #121212;
          font-weight: bold;
        ">
        <img style="width: 16px; height: 16px; margin-right: 12px" src="./image/批量结算申请@2x.png" />
        结算申请
      </el-col>
      <el-col :xs="24" :md="17" style="text-align: right">
        <!--<a style="color:#3A7DD1;cursor: pointer; margin-right: 20px" :href="downLoadUrl">下载批量结算模板</a>-->
        <!-- <el-button type="primary" @click="handleDownload"
          >下载批量结算模板</el-button
        > -->
        <!--下载批量结算模板</span>-->
        <el-button type="primary" @click="handleImport('导入结算表', 1)" v-if="role == 'COMPANY'">导入结算表</el-button>
        <el-button @click="handleImport('导入用户去检测', 2)" class="exportBtn" type="default">导入用户去检测</el-button>
        <!-- <el-button @click="handleSubmit">完成任务</el-button> -->
        <el-button @click="handleExport">导出</el-button>
        <el-button @click="handleReset">刷新</el-button>
        <el-button type="danger" @click="handleDelete">删除</el-button>
      </el-col>
    </el-row>
    <el-row style="background-color: #f3f4f4" v-if="ReceiverVisible" type="flex" class="row-bg" justify="space-between">
      <el-col :xs="24" :md="3" style="
          line-height: 40px;
          font-size: 16px;
          color: #121212;
          font-weight: bold;
        ">
        <img style="width: 16px; height: 16px; margin-right: 12px" src="./image/接收方信息@2x.png" />
        接收方信息
      </el-col>
      <el-col :xs="24" :md="18" style="text-align: right">
        <!-- <el-button type="primary" @click="receiverImport(2)"
          >批量上传验收证明</el-button
        > -->
        <!-- <el-button @click="receiverSubmit">完成任务</el-button> -->
        <el-button @click="receiverExport">导出</el-button>
        <el-button @click="receiverReset">刷新</el-button>
        <!--        <el-button type="danger" @click="receiverDelete">删除</el-button>-->
        <el-button type="info" @click="handleRevert">返回</el-button>
      </el-col>
    </el-row>
    <div v-if="ReceiverVisible !== true" class="mod-plat__plattask">
      <div class="search-form-area">
        <el-form style="padding: 20px 5px 0px" ref="form" :model="form">
          <el-row>
            <el-col :md="12" :lg="5">
              <el-form-item label-width="80px" label="发布方">
                <el-input style="width: 100%" v-model="form.dealBody" placeholder="请输出发布方"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="5">
              <el-form-item label-width="80px" label="任务大类">
                <el-select style="width: 100%" v-model="form.taskType" placeholder="请选择任务大类" clearable filterable>
                  <el-option v-for="item in taskList" :key="item.dictValue" :value="item.ticketProject"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="5">
              <el-form-item label="税源地" label-width="80px" prop="bodyId">
                <el-select v-model="form.bodyId" placeholder="请选择" style="width:100%" clearable filterable>
                  <el-option v-for="item in bodyPageList" :key="item.id" :label="`${item.bodyName}-${item.abbreviation}`"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="5">
              <el-form-item label-width="110px" label="任务发布编号">
                <el-input style="width: 100%" v-model="form.taskCode" placeholder="请输入发布编号"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="4">
              <el-form-item label-width="0px" style="margin-left: 10px">
                <div>
                  <el-button type="primary" @click="handleQuery">{{
                    $t("query")
                  }}</el-button>
                  <el-button type="info" @click="handleReset">重置</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-container">
        <el-table ref="refTable1" v-loading="" class="table" key="table1" :data="tableData" @selection-change="handleSelection" border
          style="width: 100%; background: #fff" height="500">
        <el-table-column type="selection" header-align="center" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="taskTypeName" label="任务大类" header-align="center" align="center">
        </el-table-column>
        <!-- <el-table-column
          prop="budget"
          label="预算金额（元）"
          header-align="center"
          align="center"
        >
        </el-table-column> -->
        <el-table-column prop="publishName" label="发布方" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="Receiver" label="接收方信息" header-align="center" align="center">
          <template slot-scope="scope">
            <span style="color: #3a7dd1; cursor: pointer" @click="handleSee(scope.row)">查看</span>
          </template>
        </el-table-column>

        <el-table-column prop="money" label="结算总额" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="amountPayable" label="企业应付总额" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="serviceCharge" label="综合服务费总额" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="preTaxAmount" label="税前金额" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="personalTaxAmount" label="个税" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="vatTaxAmount" label="增值税" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="additionalTaxAmount" label="增值附加税" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="individualAmount" label="个人实际收款金额" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="earnestAmount" label="保证金" header-align="center" align="center">
        </el-table-column>

        <el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="交易状态" header-align="center" align="center" width="130px">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" style="margin-left: 10px" size="small" type="warning">待审核
            </el-tag>
            <el-tag v-else-if="scope.row.status == 2" style="margin-left: 10px" size="small" type="danger">待支付
            </el-tag>
            <el-tag v-else-if="scope.row.status == 3" style="margin-left: 10px" size="small" type="success">已支付
            </el-tag>
            <el-tag v-else-if="scope.row.status == 4" size="small" type="success">部分到账</el-tag>
            <el-tag v-else-if="scope.row.status == 6" size="small" type="warning">全部到账</el-tag>
            <el-tag v-else-if="scope.row.status == 7" size="small" type="danger">交易失败待支付</el-tag>
            <el-tag v-else-if="scope.row.status == 8" size="small" type="danger">已驳回</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="申请时间" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="operation" label="操作" header-align="center" align="center" width="260px">
          <template slot-scope="scope">
            <div>
              <!-- <span  style="color:#3A7DD1;cursor: pointer;" @click="downloadVoucher(scope.row.id)" >下载验收证明</span> -->
              <!-- <span
                style="color: #3a7dd1; cursor: pointer; line-height: 15px"
                class="home_link_hover"
                @click="downloadVoucher(scope.row.id, 1)"
                >下载商户上线及任务发布信息表</span
              ><br /> -->
              <span v-if="scope.row.status == 2" style="color: #3a7dd1; cursor: pointer; line-height: 15px"
                class="home_link_hover" @click="openPayMenu()">支付</span>
              <!-- v-if="scope.row.bodyId == '1453241566079012865'" -->
              <span style="color: #3a7dd1; cursor: pointer; line-height: 15px;display: block;" class="home_link_hover"
                @click="downloadVoucher(scope.row.id, 2)">下载业务确认及服务成果验收单</span><br />
              <p style="
                  color: #3a7dd1;
                  cursor: pointer;
                  margin-left: 10px;
                  line-height: 10px;
                " v-if="!scope.row.finishProofPath2" class="home_link_hover" @click="uploadVoucher(scope.row.id, 1)">
                上传业务确认及服务成果验收单
              </p>
              <p style="
                  color: #3a7dd1;
                  cursor: pointer;
                  margin-left: 10px;
                  line-height: 10px;
                "
                v-else-if="scope.row.finishProofPath2 && ((scope.row.status == 5 || role === 'OPERATE') || (scope.row.status == 8 && role === 'COMPANY'))"
                class="home_link_hover" @click="uploadVoucher(scope.row.id, 1, scope.row)">
                修改业务确认及服务成果验收单
              </p>
              <p style="
                  color: #3a7dd1;
                  cursor: pointer;
                  margin-left: 10px;
                  line-height: 10px;
                " v-else class="home_link_hover" @click="receiverSee(scope.row)">
                查看业务确认及服务成果验收单
              </p>

              <span v-if="scope.row.status == 5 || scope.row.status == 8" class="home_link_hover"
                style="color: #3a7dd1; cursor: pointer; margin-left: 10px"
                @click="handleSettlement(scope.row)">提交结算</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="pageObject.page" :page-sizes="[10, 20, 50, 100]"
        :page-size="pageObject.limit" :total="pageObject.total" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handlePageSize" @current-change="handleCurrentPage">
      </el-pagination>
      </div>
      <el-dialog v-if="ImportVisible" :title="modalName" :visible.sync="ImportVisible" width="500px"
        :before-close="handlerCloseSubmit">
        <div class="batchImport">
          <el-form>
            <el-form-item label="税源地">
              <el-select v-model="caSyd" placeholder="请选择" style="width:60%" clearable filterable @change="sydChange">
                <el-option v-for="item in caSydList" :key="item.bodyId" :label="`${item.bodyName}-${item.abbreviation}`"
                  :value="item.bodyId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务费承担方:" prop="serviceFeeType" v-if="modalVal == 1">
              <el-radio-group v-model="serviceFeeType" v-if="serviceFeeType1 == '0,1' || serviceFeeType1 == '1,0'">
                <el-radio label="0">企业承担服务费</el-radio>
                <el-radio label="1">个人承担服务费</el-radio>
              </el-radio-group>
              <el-radio-group v-model="serviceFeeType" v-else disabled>
                <el-radio label="0">企业承担服务费</el-radio>
                <el-radio label="1">个人承担服务费</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="附    件:">
              <el-upload ref="upload" action="" accept=".xls,.xlsx" :on-change="handleChange"
                :http-request="modalVal == 1 ? fileUpload : fileUpload1" :multiple="false" :file-list="importList"
                :auto-upload="false">
                <el-button slot="trigger" size="small">选取文件</el-button>

                <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
              </el-upload>
            </el-form-item>

          </el-form>
          <el-button @click="handleDownload" class="exportBtn" v-if="modalVal == 1" type="text"
            size="small">下载结算模版</el-button>
          <el-button @click="bathImportUserDown()" class="exportBtn" v-else type="text"
            size="small">下载用户检测模板</el-button>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeSubmit">取 消</el-button>
          <el-button v-no-more-click type="primary" @click="confirmSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>












    <div v-if="ReceiverVisible" class="mod-plat__plattask">
      <div class="search-form-area">
        <el-form style="padding: 20px 5px 0px" ref="receiverForm" :model="receiverForm">
          <el-row>
            <el-col :md="12" :lg="6">
              <el-form-item label-width="110px" label="接收方">
                <el-input style="width: 100%" v-model="receiverForm.realName" placeholder="请输入接收方"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="6">
              <el-form-item label-width="110px" label="身份证">
                <el-input style="width: 100%" v-model="receiverForm.idCard" placeholder="请输入身份证"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="6">
              <el-form-item label-width="110px" label="任务接收编号">
                <el-input style="width: 100%" v-model="receiverForm.taskCode" placeholder="请输入接收编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="5">
              <el-form-item label-width="0px" style="margin-left: 10px">
                <div>
                  <el-button type="primary" @click="receiverQuery">{{
                    $t("query")
                  }}</el-button>
                  <el-button type="info" @click="receiverReset">重置</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-container">
        <el-table ref="refTable2" v-loading="" class="table" key="table2" :data="receiverTable" @selection-change="receiverSelection"
          border style="width: 100%; background: #fff">
        <el-table-column type="selection" header-align="center" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="taskCode" label="任务接收编号" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="realName" label="接收方" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="idCard" label="身份证号" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="bankAccount" label="收款账号" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="bankName" label="开户行" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="unitPrice" label="单价" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="quantity" label="数量" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="dealMoney" label="结算金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="amountPayable" label="企业应付金额" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="serviceCharge" label="综合服务费" header-align="center" align="center"></el-table-column>
        <el-table-column prop="preTaxAmount" label="税前金额" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="personalTaxAmount" label="个税" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="vatTaxAmount" label="增值税" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="additionalTaxAmount" label="增值附加税" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="earnestAmount" label="保证金" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="operation" label="操作" header-align="center" align="center" v-if="false">
          <template slot-scope="scope">
            <span v-if="
              !scope.row.finishProofPath2 &&
              (scope.row.status == 1 ||
                scope.row.status == 2 ||
                scope.row.status == 7 ||
                scope.row.status == 8)
            " style="color: #3a7dd1; cursor: pointer"
              @click="receiverUploadsVoucher(scope.row, 3)">上传业务确认及服务成果验收单</span>
            <span v-else style="color: #3a7dd1; cursor: pointer" @click="receiverSee(scope.row)">查看业务确认及服务成果验收单</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="receiverPageObject.page" :page-sizes="[10, 20, 50, 100]"
        :page-size="receiverPageObject.limit" :total="receiverPageObject.total"
        layout="total, sizes, prev, pager, next, jumper" @size-change="receiverPageSize"
        @current-change="receiverCurrentPage">
      </el-pagination>
      </div>
      <el-dialog v-if="ImportVisible" title="上传批量结算表" :visible.sync="ImportVisible" width="400px"
        :before-close="handlerCloseSubmit">
        <div class="batchImport">
          <el-upload ref="upload" action="" accept=".xls,.xlsx" :on-change="handleChange" :http-request="fileUpload"
            :multiple="false" :file-list="importList" :auto-upload="false">
            <el-button slot="trigger" size="small">选取文件</el-button>

            <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeSubmit">取 消</el-button>
          <el-button type="primary" @click="confirmSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>





























    <dialog-task v-if="dialogTaskVisible" :bodyId="caSyd" :DailogVisible="dialogTaskVisible"
      @handleTaskClose="handleTaskClose">
    </dialog-task>
    <el-dialog :title="setTit" v-if="uploadDialog" :visible.sync="uploadDialog" :before-close="uploadDiaClose">
      <div class="el-upload-list-wrap-my">
        <el-upload action="" accept="image/*,application/pdf,application/zip" list-type="picture-card"
          :file-list="fileList" :limit="1" :http-request="fileUploadVoucher"
          :class="{ imgHide: isUploadVisible || fileList.length > 0 ? true : false }">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img v-if="showPdf(file.url)" class="el-upload-list__item-thumbnail" src="../../../../assets/img/pdf.png"
              alt="" />
            <img v-else-if="showZip(file.url)" class="el-upload-list__item-thumbnail"
              src="../../../../assets/img/zip.jpg" alt="" />
            <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <span class="el-upload-list__item-actions">
              <span v-if="showPdf(file.url)" class="el-upload-list__item-preview" @click="pdfPreview(file.url)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span v-else-if="showZip(file.url)" class="el-upload-list__item-preview" @click="zipPreview(file.url)">
                <i class="el-icon-download"></i>
              </span>
              <span v-else class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span v-if="!isUploadVisible" class="el-upload-list__item-delete" @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <span v-show="!this.isViewStatus" slot="tip" class="uploadimgage">上传仅支持图片、PDF、zip文件</span>
        </el-upload>

        <el-dialog :visible.sync="previewPicDialog" append-to-body>
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>

      <span slot="footer" v-show="!this.isViewStatus" class="dialog-footer">
        <el-button type="primary" @click="fileBindTask">确 定</el-button>
        <el-button @click="uploadClose">取 消</el-button>
      </span>
    </el-dialog>
    <dialog-tips v-if="dialogTipsVisible" :DailogVisible="dialogTipsVisible" :TipsInfo="tipsInfoList"
      @handleClose="handleClose">
    </dialog-tips>
  </el-card>
</template>
<script>
import axios from "axios";
import mixinViewModule from "@/mixins/view-module";
import { addDynamicRoute } from "@/router";
import ArrayUtils from "../../../../utils/ArrayUtils";
import Cookies from "js-cookie";
import DialogTips from "./components/dialog-tips.vue";
import DialogTask from "./components/dialog-task.vue";
export default {
  name: "batch-settlement",
  data() {
    return {
      bodyPageList: [],
      serviceFeeType: '',
      serviceFeeType1: '',
      modalName: "",
      modalVal: 1,
      form: {
        bodyId: '',//税源地
        dealBody: "", //发布方
        taskType: "", //任务大类
        taskCode: "", //任务发布编码
      },
      receiverForm: {
        idCard: "", //身份证
        realName: "", //接收方
        taskCode: "", //任务发布编码
      },
      pageObject: {
        page: 1,
        limit: 10,
        total: 0,
      },
      receiverPageObject: {
        page: 1,
        limit: 10,
        total: 0,
      },
      uploadStatus: "", //1、结算单上传 2、批量上传结算表 3、接收方上传
      isUploadVisible: false, //是否查看上传凭证状态,
      dataList: [],
      receiverList: [],
      taskList: [],
      importList: [],
      ImportVisible: false,
      rowData: "",
      selectedData: [], //结算申请选中的数据
      receiverSelectedData: [], //接收方选中的数据
      ReceiverVisible: false,
      rowID: "", //结算单行ID
      receiverID: "", //接收方ID
      fileList: [], //上传文件
      batchUploadFile: [], //批量上传
      uploadDialog: false,
      previewPicDialog: false,
      dialogImageUrl: "",
      dialogTipsVisible: false,
      tipsInfoList: null,
      isViewStatus: false,
      dialogTaskVisible: false,
      role: Cookies.get("admin_role"),
      caSydList: [],
      caSyd: null
    };
  },
  components: {
    DialogTips,
    DialogTask,
  },
  prop: {},
  watch: {},
  computed: {
    tableData() {
      return this.dataList.map((item) => {
        return {
          ...item,
          taskType: ArrayUtils.getItemBy(
            this.taskList,
            "dictValue",
            item.taskType
          ).ticketProject,
          budget: item.budget ? item.budget.toFixed(2) : "",
          money: item.money ? item.money.toFixed(2) : "",
          amountPayable: item.amountPayable
            ? item.amountPayable.toFixed(2)
            : "",
          serviceCharge: item.serviceCharge
            ? item.serviceCharge.toFixed(2)
            : "",
            preTaxAmount: item.preTaxAmount ? item.preTaxAmount.toFixed(2) : '',
            personalTaxAmount: item.personalTaxAmount ? item.personalTaxAmount.toFixed(2) : '',
            vatTaxAmount: item.vatTaxAmount ? item.vatTaxAmount.toFixed(2) : '',
            additionalTaxAmount: item.additionalTaxAmount ? item.additionalTaxAmount.toFixed(2) : '',
            individualAmount: item.individualAmount ? item.individualAmount.toFixed(2) : '',
            earnestAmount: item.earnestAmount ? item.earnestAmount.toFixed(2) : ''
        };
      });
    },
    receiverTable() {
      return this.receiverList.map((item) => {
        return {
          ...item,
          unitPrice: item.unitPrice ? item.unitPrice.toFixed(2) : "",
          dealMoney: item.dealMoney ? item.dealMoney.toFixed(2) : "",
          amountPayable: item.amountPayable
            ? item.amountPayable.toFixed(2)
            : "",
          serviceCharge: item.serviceCharge
            ? item.serviceCharge.toFixed(2)
            : "",
            preTaxAmount: item.preTaxAmount ? item.preTaxAmount.toFixed(2) : '',
            personalTaxAmount: item.personalTaxAmount ? item.personalTaxAmount.toFixed(2) : '',
            vatTaxAmount: item.vatTaxAmount ? item.vatTaxAmount.toFixed(2) : '',
            additionalTaxAmount: item.additionalTaxAmount ? item.additionalTaxAmount.toFixed(2) : '',
            earnestAmount: item.earnestAmount ? item.earnestAmount.toFixed(2) : ''
        };
      });
    },
    setTit() {
      let title;
      return (title = this.isViewStatus ? "查看业务确认及服务成果验收单" : "业务确认及服务成果验收单");
    },
    //            批量结算下载模板地址
    downLoadUrl() {
      //                获取角色权限
      let rolePermissions = Cookies.get("admin_role");
      //                暂时支持的是 ： 运营角色OPERATE  企业用户 COMPANY
      if (rolePermissions === "OPERATE") {
        return "https://www.ctx666.cn/file/f01/admin_batch.xlsx";
      }
      if (rolePermissions === "COMPANY") {
        return "https://www.ctx666.cn/file/f01/company_batch.xlsx";
      }
    },
  },
  methods: {
    // 跳转支付菜单
    openPayMenu() {
      const routeParams = {
        routeName: `plat-batch-settlement-list)`,
        title: `结算列表`,
        path: "plat/batch-settlement-list",
        params: {
          activeIndex: 2
        },
      };
      // 动态路由
      addDynamicRoute(routeParams, this.$router);
    },
    sydChange(e) {
      this.serviceFeeType = ArrayUtils.getItemBy(this.caSydList, "bodyId", e).serviceFeeType
      this.serviceFeeType1 = ArrayUtils.getItemBy(this.caSydList, "bodyId", e).serviceFeeType
      console.log(this.serviceFeeType)
    },
    // 获取税源地列表
    async getBodyPageList() {
      const res = await this.$http.get('/sys/plat/body/page?page=1&limit=1000', {});
      if (res.data.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.bodyPageList = res.data.data.list
      }


      // 获取当前企业税源地列表
      const res1 = await this.$http.get(`/sys/plat/body/getCaBodyList?userId=${Cookies.get("userInfoId")}`, {});
      this.caSydList = res1.data.data
    },
    bathImportUserDown() {
      window.open("https://pg-crm-upload-uat-01.oss-cn-beijing.aliyuncs.com/lhyg1/20220402/6103bfe1df4b4dd79a85dd4964bfaeb0.xlsx");
    },
    // 上传凭证如下：

    fileUploadVoucher(file) {
      let form = new FormData();
      form.append("file", file.file);
      this.$http
        .post("/oss/file/upload2", form)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.fileList.push({ name: "", url: res.data.url });
        })
        .catch((err) => { });
    },
    showPdf(url) {
      if (url.split(".")[url.split(".").length - 1].indexOf("pdf") > -1) {
        return true;
      } else {
        return false;
      }
    },
    showZip(url) {
      if (
        url.split(".")[url.split(".").length - 1].indexOf("zip") > -1 ||
        url.split(".")[url.split(".").length - 1].indexOf("rar") > -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    zipPreview(url) {
      window.open(url);
    },
    pdfPreview(url) {
      window.open(url);
    },
    handlePictureCardPreview(file) {
      this.previewPicDialog = true;
      this.dialogImageUrl = file.url;
    },
    handleRemove(file) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          var index = this.fileList.findIndex((value, index, arr) => {
            return value.url == file.url;
          });
          if (index != -1) {
            this.fileList.splice(index, 1);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    uploadDiaClose(done) {
      this.fileList = [];
      this.isUploadVisible = false;
      this.isViewStatus = false;
      done();
    },
    uploadClose() {
      this.uploadDialog = false;
      this.fileList = [];
      this.isUploadVisible = false;
    },
    //            上传文件提交
    fileBindTask() {
      let url, data;
      if (this.uploadStatus == 1) {
        //结算单上传
        url = "/sys/plat/task/accept/batchSaveFinishProofPath2";
        data = {
          approvalId: this.rowID,
          finishProofPath2: this.fileList
            .map((item) => {
              return item.url;
            })
            .join(","),
        };
      } else if (this.uploadStatus == 2) {
        //批量上传结表
        url = "/sys/plat/task/accept/saveFinishProofPath2";
        data = {
          platTaskAcceptIdList: this.receiverSelectedData.map((item) => {
            return item.id;
          }),
          finishProofPath2: this.fileList
            .map((item) => {
              return item.url;
            })
            .join(","),
        };
      }
      this.$http.post(url, data).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg);
        }
        this.uploadDialog = false;
        this.fileList = [];
        this.uploadType = "";
        if (this.uploadStatus == 1) this.handleQuery();
        if (this.uploadStatus == 2) this.receiverQuery();
      });
      if (this.uploadStatus == 3) {
        //接收方上传
        const setUrl = "/sys/plat/task/accept";
        let params = {
          id: this.receiverID,
          finishProofPath2: this.fileList
            .map((item) => {
              return item.url;
            })
            .join(","),
        };
        this.$http.put(setUrl, params).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.uploadDialog = false;
          this.fileList = [];
          this.uploadType = "";
          this.receiverQuery();
        });
      }
    },

    //结算单如下：

    //            任务大类请求
    getDropDownData() {
      this.$http
        .get(
          "sys/plat/ticketPro/page?page=1&limit=1000&"
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.taskList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //            查询
    handleQuery() {
      this.$http
        .get(
          `/sys/plat/deal/approval/importApprovalPage?page=${this.pageObject.page
          }&limit=${this.pageObject.limit}&dealBody=${this.form.dealBody
          }&taskType=${this.form.taskType
            ? ArrayUtils.getItemBy(
              this.taskList,
              "ticketProject",
              this.form.taskType
            ).ticketProject
            : ""
          }&taskCode=${this.form.taskCode}&bodyId=${this.form.bodyId}`
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.dataList = res.data.list;
            this.pageObject.total = res.data.total;
          }
        });
    },
    //            重置
    handleReset() {
      (this.form.dealBody = ""), //发布方
        (this.form.taskType = ""), //任务大类
        (this.form.taskCode = ""); //任务发
      (this.form.bodyId = ""); //税源地
      this.handleCurrentPage(1);
      this.handleQuery();
    },
    //            下载模板
    handleDownload() {
      this.dialogTaskVisible = true;
    },
    //            导入
    handleImport(name, modalVal) {
      this.modalName = name;
      this.modalVal = modalVal;
      this.ImportVisible = true;
    },
    handleChange(file, fileList) {
      this.importList = [file];
    },
    fileUpload(file) {
      if (this.serviceFeeType == '0,1' || this.serviceFeeType == '1,2') {
        this.$message.error('请选择服务费承担方！')
        return false
      }
      let form = new FormData();
      form.append("file", file.file);
      form.append("serviceFeeType", this.serviceFeeType);
      this.$http
        .post("/sys/plat/apply/importStatement", form)
        .then(({ data: res }) => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              let _this = this;
              _this.tipsInfoList = res.data;
              _this.dialogTipsVisible = true;
            } else {
              this.$message.success("导入成功！");
            }
            this.closeSubmit();
            this.handleQuery();
          } else if (res.code == 10020) {
            //数据超过一千条进行拆分
            this.$confirm("当前数据超过1000条，是否拆分?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                const loading = this.$loading({
                  lock: true,
                  text: '上传中···',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http
                  .get("/sys/plat/apply/checkSplitMethod?status=0")
                  .then(({ data: res }) => {
                    console.log(res);
                    loading.close();
                    this.fullscreenLoading = false;
                    if (res.code == 0) {
                      if (res.data.length > 0) {
                        let _this = this;
                        _this.tipsInfoList = res.data;
                        _this.dialogTipsVisible = true;
                      } else {
                        this.$message.success("导入成功！");
                      }
                      this.closeSubmit();
                      this.handleQuery();
                    } else {
                      this.$message.error(res.msg);
                    }
                  });
              })
              .catch(() => {
                this.$message.error("请将结算数据调整后再上传!");
                this.closeSubmit();
                this.handleQuery();
              });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => { });
    },
    fileUpload1(file) {
      let form = new FormData();
      console.log(file.file.name);
      form.append("file", file.file);
      this.$http
        .post("/sys/user/importCheckUsers", form, { responseType: "blob" })
        .then(({ data: res }) => {
          // if (res.code !== 0) {
          // 	this.$message.error(res.msg);
          // 	return ;
          // }
          let str = file.file.name;
          this.exportExcel(res, str.substring(0, str.indexOf(".")));
          this.$message.success("导入成功");
          this.closeSubmit();
          this.getDataList();
        })
        .catch((err) => { });
    },
    exportExcel(data, name) {
      let blob = new Blob([data], { type: "application/vnd.ms-excel" }); // 设置文件类型excel
      let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
      // 创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
      let a = document.createElement("a");
      a.href = url;
      a.download = name + ".xlsx";
      a.click();
      // 释放这个临时的对象url
      window.URL.revokeObjectURL(url);
    },
    closeSubmit() {
      this.importList = [];
      this.ImportVisible = false;
    },
    confirmSubmit() {
      this.$refs.upload.submit();
    },
    handlerCloseSubmit(done) {
      this.closeSubmit();
      done();
    },
    //            完成任务
    handleSubmit() {
      if (this.selectedData.length > 0) {
        this.$confirm("是否需要操作当前选项?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = [];
          this.selectedData.map((item) => {
            return params.push(item.id);
          });
          this.$http
            .post("/sys/plat/task/accept/updateApprovalAcceptStatus", [
              ...params,
            ])
            .then(({ data: res }) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: res.data,
                  showClose: true,
                });
                this.handleQuery();
              } else {
                this.$message({
                  type: "warning",
                  message: res.msg,
                  showClose: true,
                });
              }
            });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择需要操作的选项",
          duration: 500,
        });
      }
    },
    //            导出
    handleExport() {
      window.open(
        `${window.SITE_CONFIG["apiURL"]
        }/sys/plat/deal/approval/exportApproval?page=${this.pageObject.page
        }&limit=${this.pageObject.limit}&dealBody=${this.form.dealBody
        }&taskType=${this.form.taskType}&taskCode=${this.form.taskCode
        }&bodyId=${this.form.bodyId}&taskCode=${this.form.taskCode
        }&access_token=${Cookies.get("access_token")}`
      );
    },
    //            查看
    handleSee(data) {
      this.receiverList = [];
      this.receiverPageObject.total = 0;
      this.rowID = data.id;
      this.ReceiverVisible = true;
      this.receiverQuery();
    },
    //            删除
    handleDelete() {
      if (this.selectedData.length > 0) {
        this.$confirm("是否要删除当前勾选的数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$nextTick(() => {
            let params = [];
            this.selectedData.map((item) => {
              return params.push(item.id);
            });
            this.$http
              .post("/sys/plat/task/accept/batchDelete", [...params])
              .then(({ data: res }) => {
                if (res.code == 0) {
                  this.$message({
                    type: "success",
                    message: "删除成功",
                    showClose: true,
                  });
                  this.handleQuery();
                } else {
                  return this.$message.error(res.msg);
                }
              });
          });
        });
      } else {
        return this.$message({
          message: this.$t("prompt.deleteBatch"),
          type: "warning",
          duration: 500,
        });
      }
    },
    //            设置选中的表格
    handleSelection(data) {
      this.selectedData = data;
    },
    //            下载验收证明
    downloadVoucher(id, num) {
      if (num == 1) {
        //下载商户上线及任务发布信息表
        window.open(
          `${window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/downloadBusinessTask?id=${id}&access_token=${Cookies.get(
            "access_token"
          )}`
        );
      } else if (num == 2) {
        //下载业务确认及服务成果验收单
        window.open(
          `${window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/downloadTaskResult?id=${id}&access_token=${Cookies.get(
            "access_token"
          )}`
        );
      }
      // window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/deal/approval/downloadCompletionCert?id=${id}&access_token=${Cookies.get('access_token')}`)
    },
    //            上传凭证
    uploadVoucher(val, type, row) {
      this.rowID = val;
      this.uploadStatus = type;
      this.uploadDialog = true;
      if (row) {
        console.log(row)
        let fileUrl;
        if (row.finishProofPath) {
          fileUrl = row.finishProofPath.split(",");
        } else {
          fileUrl = [];
        }
        if (row.finishProofPath2) {
          fileUrl = row.finishProofPath2.split(",");
        } else {
          fileUrl = [];
        }
        this.fileList = fileUrl.map((item) => {
          return {
            name: "",
            url: item,
          };
        });
      }
    },
    //            提交结算
    handleSettlement(data) {
      // if(!data.finishProofPath2){
      //   this.$message({
      //     showClose:true,
      //     type:'warning',
      //     message:'请先上传业务确认及服务成果验收单！'
      //   })
      //   return false
      // }
      this.$http
        .post("/sys/plat/deal/approval/importStatementSubmit", {
          approvalId: data.id,
        })
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.handleQuery();
            this.$message.success(res.data);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //            分页
    handlePageSize(val) {
      this.pageObject.page = 1;
      this.pageObject.limit = val;
      this.handleQuery();
    },
    //            当前页数
    handleCurrentPage(val) {
      this.pageObject.page = val;
      this.handleQuery();
    },
    //            关闭提示框
    handleClose(val) {
      this.dialogTipsVisible = val;
    },
    //            任务列表弹框状态
    handleTaskClose(val) {
      this.dialogTaskVisible = val;
    },

    // 接受方（方法\事件）如下：

    //            接收方上传凭证
    receiverUploadsVoucher(data, type) {
      this.receiverID = data.id;
      this.uploadStatus = type;
      this.uploadDialog = true;
    },
    //            接收方查看
    receiverSee(data) {
      let fileUrl;
      if (data.finishProofPath) {
        fileUrl = data.finishProofPath.split(",");
      } else {
        fileUrl = [];
      }
      if (data.finishProofPath2) {
        fileUrl = data.finishProofPath2.split(",");
      } else {
        fileUrl = [];
      }
      this.fileList = fileUrl.map((item) => {
        return {
          name: "",
          url: item,
        };
      });
      this.isUploadVisible = true;
      this.uploadDialog = true;
      this.isViewStatus = true;
    },
    //            接收方选中的表格
    receiverSelection(data) {
      this.receiverSelectedData = data;
    },
    //            接收方查询
    receiverQuery() {
      this.$http
        .get(
          `/sys/plat/task/accept/importApprovalAcceptPage?page=${this.receiverPageObject.page}&limit=${this.receiverPageObject.limit}&idCard=${this.receiverForm.idCard}&realName=${this.receiverForm.realName}&taskCode=${this.receiverForm.taskCode}&approvalId=${this.rowID}`
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.receiverList = res.data.list;
            this.receiverPageObject.total = res.data.total;
          }
        });
    },
    //            批量上传证明
    receiverImport(type) {
      if (this.receiverSelectedData.length > 0) {
        this.uploadStatus = type;
        this.uploadDialog = true;
      } else {
        this.$message.error("请选择批量上传验收证明的信息!");
      }
    },
    //            接收方完成任务
    receiverSubmit() {
      if (this.receiverSelectedData.length > 0) {
        this.$confirm("是否需要操作当前选项?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = [];
          this.receiverSelectedData.map((item) => {
            return params.push(item.id);
          });
          this.$http
            .post("/sys/plat/task/accept/updateAcceptStatus", [...params])
            .then(({ data: res }) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: res.data,
                  showClose: true,
                });
                this.receiverQuery();
              } else {
                this.$message({
                  type: "warning",
                  message: res.msg,
                  showClose: true,
                });
              }
            });
        });
      } else {
        return this.$message({
          message: "请选择操作的选项",
          type: "warning",
          duration: 500,
        });
      }
    },
    //            接受方导出
    receiverExport() {
      window.open(
        `${window.SITE_CONFIG["apiURL"]
        }/sys/plat/task/accept/exportAccept?page=${this.receiverPageObject.page
        }&limit=${this.receiverPageObject.limit}&idCard=${this.receiverForm.idCard
        }&realName=${this.receiverForm.realName}&taskCode=${this.receiverForm.taskCode
        }&approvalId=${this.rowID}&access_token=${Cookies.get("access_token")}`
      );
    },
    //            接收方刷新
    receiverReset() {
      (this.receiverForm.idCard = ""), //身份证
        (this.receiverForm.realName = ""), //接收方
        (this.receiverForm.taskCode = ""); //任务编码
      this.receiverQuery();
    },
    //            接收方删除
    receiverDelete() {
      if (this.receiverSelectedData.length > 0) {
        this.$confirm("是否需要操作删除的数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = [];
          this.receiverSelectedData.map((item) => {
            return params.push(item.id);
          });
          this.$http
            .post("/sys/plat/task/accept/delete", [...params])
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: res.data,
                  showClose: true,
                });
                this.receiverQuery();
              } else {
                this.$message({
                  type: "warning",
                  message: res.msg,
                  showClose: true,
                });
              }
            });
        });
      } else {
        return this.$message({
          message: this.$t("prompt.deleteBatch"),
          type: "warning",
          duration: 500,
        });
      }
    },
    //            返回批量结算申请
    handleRevert() {
      this.ReceiverVisible = false;
      this.handleQuery();
    },
    //            设置页数
    receiverPageSize(val) {
      this.receiverPageObject.page = 1;
      this.receiverPageObject.limit = val;
      this.receiverQuery();
    },
    //            设置当前页
    receiverCurrentPage(val) {
      this.receiverPageObject.page = val;
      this.receiverQuery();
    },
  },
  created() {
    this.getBodyPageList();
    this.getDropDownData();
    this.handleQuery();
  },
};
</script>
<style lang="scss">
.el-upload-list-wrap-my .el-upload-list--picture-card {
  margin: 0;
  display: inline;
  vertical-align: top;
}

.el-upload-list-wrap-my .el-upload-list__item:first-child {
  margin-top: 0px !important;
}

.imgHide .el-upload--picture-card {
  display: none;
}

.uploadimgage {
  text-align: center;
  margin-top: 5px;
  display: block;
}

.mod-plat__plattask {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);

  .search-form-area {
    flex-shrink: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;

    .el-table {
      flex: 1;
      overflow: auto;
    }

    .el-pagination {
      flex-shrink: 0;
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>